<!--
	its frontend

	Page, submodule from App

    @file         Page_hello.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


 <script>
    import { PAGE }                 from './config';
    import { URL_API } 	            from './minions';
    import { SunIcon, ApertureIcon, AwardIcon }  from 'svelte-feather-icons';


    import {createEventDispatcher}  from "svelte";
    let dispatch =  createEventDispatcher();



// =================================== Login =================================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });


    
// ========================= Delete old imageFiles ===========================


    //=> Clean old processed images on server
    const deleteOldImagefiles = async evt=> {

        if (evt.key=== 'D'){

            const reply = await fetch(URL_API("cleanup"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(login)});

 

            if (reply && reply.ok) {
                    console.log('Old image files deleted.');
            }
            else {
                console.log('Deleting failed');
                
            }
        }
        
    };//deleteOldImagefiles()



// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {

        document.addEventListener("keydown", deleteOldImagefiles, true);

    });//onMount()


    function close(nextPage="") {
        dispatch('close', {page: nextPage});
    }//close()


	onDestroy(async () => {
        document.removeEventListener("keydown", deleteOldImagefiles);
	});//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->



<div class="page">

    <h1>ITS</h1>

    <h3>TLCexplorer Image Test Suite</h3>


    <button class="btn" on:click={()=>close(PAGE.liPro)}>
        <SunIcon size="0.8x"/> Illumination
    </button>

    <button class="btn" on:click={()=>close(PAGE.liProLight)}>
        <SunIcon size="0.8x"/> Illum. Quick Test
    </button>

    {#if login.level >= 100}        
    <button class="btn" on:click={()=>close(PAGE.camTe)}>
        <ApertureIcon size="0.8x"/> Camera
    </button>
    {/if}

    <button class="btn" on:click={()=>close(PAGE.benMa)}>
        <AwardIcon size="0.8x"/>  Benchmark
    </button>


</div>



<!-- ============================  S T Y L E  ============================ -->



<style>
	.page {
        width: 100%;
        max-width: 600px;
        margin-top: 2em;
        margin-left: auto;
        margin-right: auto;
        padding: 2em;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        margin-top: 3em;
    }

    h3 {
        border-top: 1px solid var(--tF-gray);
        padding: 1em 2em;
        margin: 1em auto;
    }

    .btn {
        width: 100%;
        font-size: 1.5em;
        margin-right: 0px;
        margin-top: 1.5em;
    }


</style>